// Convert FastAPI/axios error payloads into render-safe text. FastAPI may put a
// structured object in `detail`; React cannot render that object directly.
export const apiErrorMessage = (error, fallback) => {
  const payload = error?.response?.data;
  const detail = payload?.detail ?? payload?.message;

  if (typeof detail === 'string' && detail.trim()) return detail;
  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim()) {
      return detail.message;
    }
    if (typeof detail.detail === 'string' && detail.detail.trim()) {
      return detail.detail;
    }
  }
  if (typeof payload === 'string' && payload.trim()) return payload;
  if (typeof error?.message === 'string' && error.message.trim()) return error.message;
  return fallback;
};
